import { cn } from '@/utils/tailwind-merge';
import { ChevronDown } from 'lucide-react';
import { forwardRef, useRef } from 'react';

export interface IAccordion {
    title: string;
    content: React.ReactElement;
    index?: number;
    isOpen?: boolean;
    // eslint-disable-next-line no-unused-vars
    toggleAccordion?: (index: number) => void;
    className?: string;
}

const Accordion = forwardRef<HTMLDivElement, IAccordion>(function Accordion(
    { title, content, index = 0, isOpen, toggleAccordion = () => {}, className },
    ref,
) {
    const contentRef = useRef<HTMLDivElement>(null);

    return (
        <div className={cn('w-full flex flex-col pt-4 lg:pt-8', className)}>
            <div
                className="flex justify-between items-center w-full text-left focus:outline-none gap-7 border-b border-white/50"
                role="button"
                onClick={() => toggleAccordion(index)}
            >
                <div className="flex justify-between items-center w-full">
                    <h3 className="w-5/6 font-bold text-h4 lg:text-h1 leading-none pb-2 lg:pb-3">
                        {title}
                    </h3>
                    <ChevronDown
                        className={cn(
                            'ml-8 scale-125 transition-transform duration-300 text-white min-w-6 min-h-6 lg:min-w-10 lg:min-h-10',
                            isOpen && 'rotate-180',
                        )}
                        height={48}
                    />
                </div>
            </div>
            <div
                ref={ref}
                className="flex items-center w-full overflow-hidden transition-all duration-300 ease-in-out text-left gap-7 leading-tight"
                style={{
                    maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0px',
                    opacity: isOpen ? 1 : 0,
                }}
            >
                <div className="w-full" ref={contentRef}>
                    {content}
                </div>
            </div>
        </div>
    );
});

export default Accordion;
